import * as userActions from '@titan/devkit/user';
import { createReducer, on } from '@ngrx/store';

export const LOGIN_PAGE_FEATURE_KEY = 'loginPage';

export interface State {
    error: string | null;
    pending: boolean;
    username: string | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    username: null,
};

export const reducer = createReducer(
    initialState,
    on(userActions.login, state => ({
        ...state,
        pending: true,
        error: null,
    })),
    on(userActions.authenticateSuccess, state => ({
        ...state,
        error: null,
        pending: false,
    })),
    on(userActions.loginFailed, (state, action) => ({
        ...state,
        error: action.payload.message,
        pending: false,
    })),
    on(userActions.setUsername, (state, action) => ({
        ...state,
        username: action.payload,
    }))
);

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getUsername = (state: State) => state.username;
